import service from '@services/cities/fetchCityAreaById';
import { errorAction } from '@shared/actions';
import { FETCH_AREA_BY_ID } from '../actionTypes';

const type = FETCH_AREA_BY_ID;

const errorMessage = 'Ocurrió un error al obtener el área';

const fetchAreaById = ({ areaId }) => async (dispatch, getState, axios) => {
  try {
    const response = await service({ axios, areaId });

    return response.data;
  } catch (error) {
    dispatch(errorAction({ type, errorMessage, error, areaId }));
    return {};
  }
};

export default fetchAreaById;
